"use client";

import React, { useState } from "react";
import { CountryInfo } from "@/store/types/countryTypes";
import AnonymousRouteLeadModal from "../common/AnonymousRouteLeadModal";

interface CountryBottomCtaProps {
  country: CountryInfo;
}

const CountryBottomCta: React.FC<CountryBottomCtaProps> = ({ country }) => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToUniversities = () => {
    const el = document.getElementById("universities");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 600, behavior: "smooth" });
    }
  };

  return (
    <>
      <div
        className="w-full rounded-[24px] py-8 sm:py-10 px-6 sm:px-10 flex flex-col md:flex-row items-center justify-between gap-6 my-12 shadow-xl"
        style={{
          background: `linear-gradient(0deg, #0A1730, #0A1730), radial-gradient(55.56% 226.09% at 10% 0%, rgba(91, 79, 229, 0.55) 0%, rgba(0, 0, 0, 0) 60%)`,
        }}
      >
        <div className="text-center md:text-left space-y-1.5">
          <h3 className="text-2xl sm:text-3xl font-bold text-white ff_poppins">
            Ready to take the next step?
          </h3>
          <p className="text-xs sm:text-sm text-white/70 ff_poppins">
            Talk to a counsellor to shortlist your universities.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-3.5 w-full sm:w-auto">
          <button
            onClick={() => setIsOpen(true)}
            className="w-full sm:w-auto px-7 py-3 rounded-full border border-white/30 text-white font-semibold text-sm sm:text-base ff_poppins hover:bg-white/10 transition-colors cursor-pointer"
          >
            Talk to Mentor
          </button>

          <button
            onClick={scrollToUniversities}
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-gradient-to-r from-[#2b7fff] to-[#9b51e0] text-white font-semibold text-sm sm:text-base ff_poppins shadow-lg shadow-blue-600/30 hover:scale-[102%] transition-all cursor-pointer"
          >
            View Universities
          </button>
        </div>
      </div>

      <AnonymousRouteLeadModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isAnonymous={true}
        platform="enquiry_form"
        source="country_page"
      />
    </>
  );
};

export default CountryBottomCta;
